/**
 * Displays a profile with a button to create the actual profile
 */
import React from 'react';
import PropTypes from 'prop-types';
import { createUrl } from '../../../utils/createUrl';

export default class OnboardingCompanyRadioButton extends React.Component {
    static propTypes = {
        companyId: PropTypes.number.isRequired,
        registerSelectedCompany: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        _links: PropTypes.shape({
            'emp:profile': PropTypes.arrayOf(
                PropTypes.shape({
                    href: PropTypes.string.isRequired,
                })
            ),
        }),
    };

    onChange = () => {
        const company = {
            title: this.props.title,
            companyId: this.props.companyId,
        };
        this.props.registerSelectedCompany(company);
    };

    alreadyHasProfile(company) {
        if (company && company._links) {
            return 'emp:profile' in company._links;
        }
    }

    renderCompanyLink(text) {
        const profileId =
            this.props._links['emp:profile'][0].href.match(/\d+$/)[0];

        return <a href={createUrl(`company/${profileId}`)}>{text}</a>;
    }

    renderDisabled() {
        return (
            <div className="input-toggle">
                <input
                    disabled
                    id={`sel-${this.props.title}`}
                    name="select-profile"
                    type="radio"
                />
                <label htmlFor={`sel-${this.props.title}`}>
                    <span className="u-strikethrough">{this.props.title}</span>
                    <span>
                        {' '}
                        (Det finnes allerede en{' '}
                        {this.renderCompanyLink('profil')} for denne bedriften)
                    </span>
                </label>
            </div>
        );
    }

    renderEnabled() {
        return (
            <div className="input-toggle">
                <input
                    id={`sel-${this.props.title}`}
                    name="select-profile"
                    onChange={this.onChange}
                    type="radio"
                />
                <label htmlFor={`sel-${this.props.title}`}>
                    {this.props.title}
                </label>
            </div>
        );
    }

    render() {
        return this.alreadyHasProfile(this.props)
            ? this.renderDisabled()
            : this.renderEnabled();
    }
}
